import { Dialog as MaterialDialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, ButtonProps } from "@mui/material";
import { useState, useEffect, FC, ReactNode } from "react";


export interface DialogAction {
    label: string;
    onClick: () => void;
    isDisabled?: boolean;
    color?: ButtonProps['color'];
    triggerClose?: boolean;
    contained?: boolean;
}

export interface DialogProperties {
    isOpen: boolean;
    title: string;
    width?: string | number;
    content?: ReactNode;
    actions: DialogAction[];
    onClose?: Function
}


const Dialog: FC<DialogProperties> = ({
    isOpen,
    title = "",
    content,
    actions,
    width = "600px",
    onClose,
    children,
}) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleClose = (): void => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    }

    const slugfy = (label: string): string => {
        return label.replace(/[^0-9A-Za-z-]/gm, "-");
    }

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen])

    return <>
        <MaterialDialog open={open} onClose={handleClose} aria-labelledby={slugfy(title)} >
            <DialogTitle id={slugfy(title)}>{title}</DialogTitle>
            <DialogContent style={{ width: width }}>
                {content ? <DialogContentText>{content}</DialogContentText> : ""}
                {children ? children : ""}
            </DialogContent>
            <DialogActions style={{ paddingRight: "29px", paddingBottom: "20px" }}>
                {actions.length === 0 ?
                    <>
                        <div className="row">
                            <div className="X12">
                                <Button onClick={handleClose} color="primary">
                                    Fechar
                                </Button>
                            </div>
                        </div>
                    </>
                    :
                    actions.map((act: DialogAction) => {
                        return <>
                            <Button
                                disableElevation
                                variant={act.contained ? "contained" : "text"}
                                disabled={act.isDisabled}
                                color={act.color}
                                onClick={() => {
                                    act.onClick();
                                    if (act.triggerClose) {
                                        handleClose();
                                    }
                                }}
                            >
                                {act.label}
                            </Button>
                        </>
                    })
                }
            </DialogActions>
        </MaterialDialog>
    </>
}

export { Dialog }